import Parse from 'parse'

export default {
  async changeLang ({ state, commit }, value) {
    commit('setCurrent', value)
    commit('changeLang')
  },

  async fetch ({ commit, dispatch }) {
    const user = Parse.User.current()
    if (!user) {
      return
    }

    const query = new Parse.Query('UserLocale')
    query.equalTo('user', user)
    const userLocale = await query.first()

    if (!userLocale) {
      return
    }

    dispatch('changeLang', userLocale.get('name'))
    commit('setUserLocale', userLocale)
  },

  async save ({ state, commit }) {
    let userLocale = state.userLocale
    if (!userLocale) {
      userLocale = new Parse.Object('UserLocale')
    }

    const user = Parse.User.current()
    if (user) {
      userLocale.set('name', state.current)
      userLocale.set('user', user)
      commit('setUserLocale', await userLocale.save())
    }
  }
}
